export default __webpack_public_path__ + "static/media/login.e0424dc2.png";